module.exports = __webpack_public_path__ + "media/images/gallery/constellations/delphinus/del_gc-a1c292c4f476e0adfd4a29c15e550632.gif";